
import React from 'react';
import HowItWorksHero from '../HowItWorksHero';

const HeroSection = () => {
  return <HowItWorksHero />;
};

export default HeroSection;
